<router-outlet></router-outlet>

<p-toast position="bottom-right" key="success-warn"></p-toast>
